<app-breadcrumb [title]="'Colaboradores'" [items]="['PESV', 'Diagnostico']"
  [active_item]="'Colaboradores'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-people me-2"></i>
      <h5 class="mb-0"><strong>COLABORADORES PESV</strong></h5>
    </div>

    <div class="card-body">
      <div class="row mb-3">
        <div class="col-sm-12 col-md-4 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar por documento, nombre, cargo, correo..."
              [(ngModel)]="filtro" (input)="aplicarFiltro()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="cargando" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <div *ngIf="!cargando" class="table-responsive tabla-con-scroll">
        <table class="table table-hover table-bordered align-middle mb-0" id="tblColaboradoresPesv">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>TIPO</strong></th>
              <th class="text-center"><strong>DOCUMENTO</strong></th>
              <th class="text-center" style="cursor: pointer" (click)="sortData('nombreCompleto')">
                <strong>NOMBRES Y APELLIDOS</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'nombreCompleto' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'nombreCompleto' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'nombreCompleto'
                }"></i>
              </th>
              <th class="text-center"><strong>FECHA DE NACIMIENTO</strong></th>
              <th class="text-center"><strong>GENERO</strong></th>
              <th class="text-center"><strong>CARGO</strong></th>
              <th class="text-center"><strong>NIVEL ESCOLAR</strong></th>
              <th class="text-center"><strong>ESTADO CIVIL</strong></th>
              <th class="text-center"><strong>ACCIÓN</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let persona of colaboradoresFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
              <td class="text-center">{{ persona.tipo || '-' }}</td>
              <td class="text-center">{{ persona.cedula || '-' }}</td>
              <td class="text-uppercase">{{ nombreCompleto(persona) || '-' }}</td>
              <td class="text-center">{{ formatearFechaNacimiento(persona.fechanace) }}</td>
              <td class="text-center">{{ persona.genero || '-' }}</td>
              <td class="text-center">{{ persona.cargoData?.cargos || '-' }}</td>
              <td class="text-center">{{ obtenerTituloAcademias(persona) }}</td>
              <td class="text-center">{{ persona.estadoCivil?.descripcion || '-' }}</td>
              <td class="text-center accion-fila">
                <button type="button" class="btn btn-sm btn-outline-primary me-1"
                  (click)="abrirModalFormularioColaborador(formularioColaboradorModal, persona)">
                  Diagnóstico
                </button>
              </td>
            </tr>
            <tr *ngIf="!colaboradoresFiltrados.length">
              <td colspan="9" class="text-center py-3">No se encontraron colaboradores.</td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <div class="d-flex align-items-center">
            <label for="pageSizeColaboradores" class="me-2">Mostrar:</label>
            <select id="pageSizeColaboradores" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por pagina</span>
          </div>

          <div class="text-center flex-grow-1">
            Total Registros:
            <a class="badge badge-primary"><b>{{ colaboradoresFiltrados?.length || 0 }}</b></a>
          </div>

          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
              previousLabel="Anterior" nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>

        <div class="mt-4">
          <div class="btn-showcase text-center">
            <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
              (click)="exportarExcel('tblColaboradoresPesv','listado_colaboradores_pesv')">
              <i class="icofont icofont-file-excel"></i> EXCEL
            </button>

            <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
              (click)="exportToPDF('tblColaboradoresPesv','listado_colaboradores_pesv','Listado Colaboradores PESV')">
              <i class="icofont icofont-file-pdf"></i> PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #formularioColaboradorModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">Diagnóstico</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body" *ngIf="colaboradorModalSeleccionado as colaborador">
    <ngb-accordion [closeOthers]="true" [activeIds]="'panel-1'" [destroyOnHide]="false">
      <ngb-panel id="panel-1">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-id-card"></i>
          <span class="ms-2"><strong>1. DATOS BÁSICOS</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label"><strong>NÚMERO DE DOCUMENTO:</strong></label>
              <input class="form-control" [value]="colaborador.cedula || '-'" disabled />
            </div>
            <div class="col-md-6">
              <label class="form-label"><strong>NOMBRES Y APELLIDOS:</strong></label>
              <input class="form-control text-uppercase" [value]="nombreCompleto(colaborador) || '-'" disabled />
            </div>
            <div class="col-md-6">
              <label class="form-label"><strong>CATEGORÍA:</strong></label>
              <input class="form-control" [value]="colaborador.categoria || '-'" disabled />
            </div>
            <div class="col-md-6">
              <label class="form-label"><strong>VIGENCIA DE LICENCIA:</strong></label>
              <input class="form-control" [value]="formatearFechaNacimiento(colaborador.vencelic)" disabled />
            </div>
          </div>
        </ng-template>
      </ngb-panel>

     
      <ngb-panel id="panel-2">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-badge"></i>
          <span class="ms-2"><strong>2. CAPACITACIÓN Y CONTROL</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row g-3">
            <table class="table table-hover table-bordered" id="tblAsistencias">
              <thead class="bg-primary">
                <tr>
                <th class="text-center"><strong>FECHA</strong></th>
                  <th class="text-center" style="cursor: pointer">
                    <strong>CAPACITACIÓN</strong>
                    <i class="fa"></i>
                  </th>                

                  <th class="text-center"><strong>ASISTIÓ</strong></th>
                  <th class="text-center"><strong>APROBADO/EVALUACIÓN COMPETENCIAS</strong></th>
                  

                  
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let asistencia of participantes">
                   <td class="text-center">{{ asistencia.fechaCreacion | date:'dd/MM/yyyy' }}</td>
                  <td class="text-center">{{ asistencia.capacitacion?.nombre || '-' }}</td>                 
                  <td class="text-center">{{ asistencia.asistio ? 'Sí' : 'No' }}</td>
                  <td class="text-center">{{ asistencia.aprobo ? 'Sí' : 'No' }}</td>
                </tr>
               

              </tbody>
            </table>
      <!--       <div class="col-md-4">
              <label class="form-label"><strong>HA RECIBIDO CAPACITACIÓN</strong></label>
              <select class="form-select" [ngModel]="obtenerRegistroFila(colaborador)?.capacitacion" (ngModelChange)="actualizarCampoFila(colaborador, 'capacitacion', $event)">
                <option *ngFor="let opcion of opcionesSiNo" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div>

            <div class="col-md-8">
              <label class="form-label"><strong>TEMAS DE CAPACITACIÓN</strong></label>
              <input class="form-control" [value]="obtenerTemaCapacitacion(colaborador)" disabled />
            </div>

            <div class="col-md-4">
              <label class="form-label"><strong>EVAL. COMPETENCIA</strong></label>
              <select class="form-select" [ngModel]="obtenerRegistroFila(colaborador)?.evaluacion_competencia" (ngModelChange)="actualizarCampoFila(colaborador, 'evaluacion_competencia', $event)">
                <option *ngFor="let opcion of opcionesSiNo" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div> -->
            
          </div>
        </ng-template>
      </ngb-panel>

            <ngb-panel id="panel-3">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-traffic-light"></i>
          <span class="ms-2"><strong>3. SINIESTROS VIALES - ÚLTIMOS 5 AÑOS</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row g-3">
            <table class="table table-hover table-bordered" id="tblSiniestros">
                <thead class="bg-primary">
                  <tr>
                    <th class="text-center"><strong>CONSECUTIVO</strong></th>
                    <th class="text-center"><strong>FECHA</strong></th>
                    <th class="text-center" style="cursor: pointer">
                      <strong>TIPO DE SINIESTRO</strong>
                      <i class="fa"></i>
                    </th>                
                    <th class="text-center"><strong>DESCRIPCIÓN</strong></th>
                    <th class="text-center">ROL</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let siniestro of siniestros">
                    <td class="text-center">{{ siniestro.siniestroVialData?.consecutivo || '-' }}</td>
                    <td class="text-center">{{ siniestro.fechaCreacion | date:'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ siniestro.siniestroVialData?.tipoSiniestroData.nombre || '-' }}</td>                 
                    <td class="text-center">{{ siniestro.siniestroVialData?.descripcion_ocurrido || '-' }}</td>
                    <td class="text-center">{{ siniestro.tipo_actor_vial_descripcion || '-' }}</td>
                  </tr>
                  <tr *ngIf="!siniestros?.length">
                    <td class="text-center py-3" colspan="5">No tiene siniestros registrados.</td>
                  </tr>
                </tbody>
            </table>
            <div class="col-12" *ngIf="siniestros?.length">
              <div class="card border-start border-4 border-primary shadow-sm mb-2">
                <div class="card-body py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div>
                    <h6 class="mb-1 text-primary"><strong>SINIESTROS REPORTADOS</strong></h6>
                    <small class="text-dark">Total registrado para este colaborador</small>
                  </div>
                  <span class="badge bg-primary fs-6 px-3 py-2">{{ siniestros?.length || 0 }}</span>
                </div>
              </div>
            </div>
           <!--   <div class="col-md-4" *ngIf="banderaSiniestros">
              
              <label class="form-label"><strong>SINIESTROS VIALES ÚLTIMOS 5 AÑOS</strong></label>
              <select class="form-select" [ngModel]="obtenerRegistroFila(colaborador)?.sufrio_siniestros" (ngModelChange)="actualizarCampoFila(colaborador, 'sufrio_siniestros', $event)">
                <option *ngFor="let opcion of opcionesSiNo" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div>

            <div class="col-md-4" *ngIf="banderaSiniestros">
              <label class="form-label"><strong>ROL COMO ACTOR VIAL</strong></label>
              <select class="form-select" [ngModel]="obtenerRegistroFila(colaborador)?.rol_desplazamiento" (ngModelChange)="actualizarCampoFila(colaborador, 'rol_desplazamiento', $event)">
                <option *ngFor="let opcion of opcionesRolVial" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div> -->

            
          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="panel-4">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-people"></i>
          <span class="ms-2"><strong>4. ROL Y MOVILIDAD</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row g-3">

            <div class="col-md-4">
              <label class="form-label"><strong>MEDIO DE TRANSPORTE:</strong></label>
              <ng-select [items]="opcionesMedioTransporte" bindLabel="label" bindValue="value" [searchable]="true" [clearable]="false"
                [ngModel]="obtenerRegistroFila(colaborador)?.medio_transporte"
                (ngModelChange)="actualizarCampoFila(colaborador, 'medio_transporte', $event)" placeholder="Seleccione un medio de transporte">
              </ng-select>
              <small class="text-danger" *ngIf="!obtenerRegistroFila(colaborador)?.medio_transporte">
                Debe seleccionar una opcion.
              </small>
              <!-- <select class="form-select" [ngModel]="obtenerRegistroFila(colaborador)?.medio_transporte" (ngModelChange)="actualizarCampoFila(colaborador, 'medio_transporte', $event)">
                <option *ngFor="let opcion of opcionesMedioTransporte" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select> -->
            </div>

            <div class="col-md-4">
              <label class="form-label"><strong>ROL DE CONDUCTOR PARA DESPLAZAMIENTOS:</strong></label>
              <ng-select [items]="opcionesRolVial" bindLabel="label" bindValue="value" [searchable]="true" [clearable]="false"
                [ngModel]="obtenerRegistroFila(colaborador)?.rol_desplazamiento"
                (ngModelChange)="actualizarCampoFila(colaborador, 'rol_desplazamiento', $event)" placeholder="Seleccione una opción">
              </ng-select><!--
              <select class="form-select" >
                <option value="1" >SI</option>
                <option value="0">NO</option>
              </select> -->
            </div>

            <div class="col-md-4">
              <label class="form-label"><strong>TIPO DE VEHÍCULO MAS FRECUENTE:</strong></label>
              <ng-select [items]="opcionesVehiculo" bindLabel="label" bindValue="value" [searchable]="true" [clearable]="false"
                [ngModel]="obtenerRegistroFila(colaborador)?.vehiculo_frecuente"
                (ngModelChange)="actualizarCampoFila(colaborador, 'vehiculo_frecuente', $event)" placeholder="Seleccione un vehículo">
              </ng-select><!-- 
              <select class="form-select"  [ngModel]="obtenerRegistroFila(colaborador)?.vehiculo_frecuente" (ngModelChange)="actualizarCampoFila(colaborador, 'vehiculo_frecuente', $event)">
                <option *ngFor="let opcion of opcionesVehiculo" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select> -->
            </div>
          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="panel-5">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-listing-box"></i>
          <span class="ms-2"><strong>5. INFRACCIONES DE TRÁNSITO</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row g-3">
           
             <table>
              <thead class="bg-primary">
                <tr>
                  <th class="text-center"><strong>FECHA</strong></th>
                  <th class="text-center"><strong>INFRACCIÓN</strong></th>
                  <th class="text-center"><strong>ESTADO DE PAGO</strong></th>
                   <th class="text-center"><strong>TIPO DE INFRACCIÓN</strong></th>
                  <th class="text-center"><strong>OBSERVACIONES</strong></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let infraccion of infracciones">
                  <td class="text-center">{{ infraccion.fecha | date:'dd/MM/yyyy' }}</td>
                  <td class="text-center">{{ infraccion.codigo || '-' }}</td>
                  <td class="text-center">{{ infraccion.estadoMulta.descripcion || '-' }}</td>
                  <td class="text-center">-</td>
                  <td class="text-center">{{ infraccion.observaciones || '-' }}</td>
                </tr>
                <tr *ngIf="!infracciones?.length">
                  <td class="text-center py-3" colspan="4">No tiene infracciones registradas.</td>
                </tr>
             </table> 

              <div class="col-md-4">
              <label class="form-label"><strong>CANTIDAD</strong></label>
              <input class="form-control" [ngModel]="infracciones.length" value="" disabled />
            </div>
            

            

            <div class="col-md-4">
              <label class="form-label"><strong>N° DE PAZ Y SALVO:</strong></label>
              <input class="form-control" [ngModel]="obtenerRegistroFila(colaborador)?.numero_paz"
                (ngModelChange)="actualizarCampoFilaTexto(colaborador, 'numero_paz', $event)"
                />
            </div>

            <div class="col-md-4">
              <label class="form-label"><strong>FECHA ÚLTIMA REVISIÓN</strong></label>
              <input class="form-control" type="date" [ngModel]="obtenerRegistroFila(colaborador)?.fecha_ultima_revision"
                (ngModelChange)="actualizarCampoFilaTexto(colaborador, 'fecha_ultima_revision', $event)"
                 />
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cerrar</button>
    <button type="button" class="btn btn-primary" (click)="guardarFormularioModal(modal)">Guardar</button>
  </div>
</ng-template>